import { MOBIL_DICT, MOBIL_SERVICE_KEYS } from "@/lib/mobilI18n";

export const MOBILE_STATUSES = {
  pending: { label: "Pendent", chip: "bg-[#E2C9A0]/40 text-[#7a5a1c] border border-dashed border-[#C9A24B]" },
  confirmed: { label: "Confirmat", chip: "bg-[#3e664c] text-[#fdfcf9] border border-[#3e664c]" },
  completed: { label: "Realitzat", chip: "bg-[#6F8C76]/20 text-[#2e5949] border border-[#6F8C76]/40" },
  cancelled: { label: "Cancel·lat", chip: "bg-[#eae0df]/60 text-[#5C544F] border border-[#eae0df] line-through" },
};

export const MOBILE_SERVICE_LABELS = MOBIL_SERVICE_KEYS.map((k) => MOBIL_DICT.ca.services.items[k].title);

export const formatAdminDate = (iso) =>
  iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("ca-ES", { day: "2-digit", month: "short", year: "numeric" }) : "";

export const adminLabelCls = "text-xs uppercase tracking-[0.18em] text-[#5C544F]";
